const ACTIVE_STATUSES = ["pending", "queued", "processing", "cancel_requested"];

export const ADMIN_REPORT_JOB_STATUS_FILTERS = {
  all: undefined,
  active: ACTIVE_STATUSES,
  stuck: ACTIVE_STATUSES,
  failed: ["failed"],
  cancelled: ["cancelled"],
  complete: ["complete"],
};

export const adminReportJobStatuses = filter =>
  ADMIN_REPORT_JOB_STATUS_FILTERS[filter] || undefined;

export const canAdminCancelReportJob = job =>
  ["pending", "queued", "processing"].includes(job?.status);

export const canAdminRetryReportJob = job =>
  ["failed", "cancelled"].includes(job?.status) || Boolean(job?.canRetry);

export const reportJobLastActivity = job =>
  job?.cancelledAt ||
  job?.completedAt ||
  job?.lastAttemptAt ||
  job?.startedAt ||
  job?.createdAt ||
  null;

export const formatElapsedTime = (from, to = new Date()) => {
  if (!from) return "—";
  const milliseconds = Math.max(
    new Date(to).getTime() - new Date(from).getTime(),
    0,
  );
  const minutes = Math.floor(milliseconds / 60000);
  if (minutes < 1) return "<1m";
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return remainingMinutes ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
};

export const reportJobAge = (job, now = new Date()) =>
  formatElapsedTime(
    job?.createdAt,
    job?.completedAt || job?.cancelledAt || now,
  );

export const adminReportJobInput = ({
  statusFilter,
  report,
  correlationId,
  userId,
  createdFrom,
  createdTo,
  limit,
  offset,
}) => ({
  status: adminReportJobStatuses(statusFilter),
  ...(statusFilter === "stuck" ? { stuckOnly: true } : {}),
  ...(report?.trim() ? { reports: [report.trim()] } : {}),
  ...(correlationId?.trim() ? { correlationId: correlationId.trim() } : {}),
  ...(userId ? { userId: Number(userId) } : {}),
  ...(createdFrom
    ? { createdFrom: new Date(`${createdFrom}T00:00:00`).toISOString() }
    : {}),
  ...(createdTo
    ? { createdTo: new Date(`${createdTo}T23:59:59.999`).toISOString() }
    : {}),
  limit,
  offset,
});
